export default __webpack_public_path__ + "static/rex-writer-5dfe33a0109cddd31f1026712441c1a5.svg";